import { useEffect } from "react";
import { useRouter } from "next/router";

const referralTags = ["r"];

export function useReferralTracker(): void {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;

    referralTags.forEach((tag) => {
      const existing = localStorage.getItem(tag);

      if (typeof router.query[tag] === "string") {
        const value = (router.query[tag] as string).trim().toLowerCase();
        if (!existing || existing !== value) {
          localStorage.setItem(tag, value);
        }
      }
    });
  }, [router.isReady, router.query]);
}

export function getReferrer(): string {
  if (typeof window === "undefined") return "";
  return localStorage.getItem("r") ? encodeURIComponent(localStorage.getItem("r") || "") : "";
}
